import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/quiz/question-types',
      method: 'get',
      params: params
  })
}

export function inventory(params) {
  return request({
      url: '/quiz/question-type/inventory',
      method: 'get',
      params
  })
}

export function show(id) {
  return request({
      url: `/quiz/question-types/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/quiz/question-types',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `/quiz/question-types/${data.id}`,
      method: 'put',
      data
  })
}

export function destroy(id) {
  return request({
      url: `/quiz/question-types/${id}`,
      method: 'delete',
  })
}
